// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorVendorTypeChangeRequests = (client) => ({
    /**
     * `POST /vendor/vendor-type-change-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorTypeChangeRequestsCreate
     * @source apps/backend/src/api/vendor/vendor-type-change-requests/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/vendor-type-change-requests", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/vendor-type-change-requests/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorTypeChangeRequestsIdDelete
     * @source apps/backend/src/api/vendor/vendor-type-change-requests/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/vendor-type-change-requests/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/vendor-type-change-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorTypeChangeRequestsDelete
     * @source apps/backend/src/api/vendor/vendor-type-change-requests/route.ts
     */
    deleteBatch: (body, query, headers) => client.fetch("/vendor/vendor-type-change-requests", { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/vendor-type-change-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorTypeChangeRequestsList
     * @source apps/backend/src/api/vendor/vendor-type-change-requests/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/vendor-type-change-requests", { method: "GET", query, headers }),
});
//# sourceMappingURL=vendor-type-change-requests.js.map